








import Component from 'vue-class-component'
import LoginContainer from '@/components/authentication/login-container/LoginContainer.component'
import {Action, Getter} from 'vuex-class'
import {AuthenticationRequest, PortalType} from '@payroll/optimus-common'
import {StoreNamespace} from '@/globals/StoreNamespaceGlobal'
import FeedbackComponent from "../../base/FeedbackComponent";

@Component({
    components: {
        LoginContainer
    }
})
export default class ForgotPasswordComponent extends FeedbackComponent {

    private forgotPasswordAuth: AuthenticationRequest = {} as AuthenticationRequest

    @Getter('mngCompanyName', StoreNamespace.AUTHENTICATION) mngCompanyName!: string
    @Action('sendForgotPwdMail', StoreNamespace.AUTHENTICATION) sendForgotPwdMail: any

    mounted() {
        if (!this.mngCompanyName) {
            this.$router.push({name: 'not-found'})
        } else {
            this.forgotPasswordAuth.managingCompany = this.mngCompanyName
            this.forgotPasswordAuth.portalType = PortalType.BACKOFFICE
        }
    }

    onLogin() {
        this.sendForgotPwdMail({requestBody: this.forgotPasswordAuth, requestorCallback: this})
    }

    onSuccess(data?: any, requestName?: string, message?: string): void {
        this.$router.push({name: 'mailsent'})
    }
}
